import { render, staticRenderFns } from "./LcFormButtonBar.vue?vue&type=template&id=4900ff05&scoped=true"
import script from "./LcFormButtonBar.vue?vue&type=script&lang=js"
export * from "./LcFormButtonBar.vue?vue&type=script&lang=js"
import style0 from "./LcFormButtonBar.vue?vue&type=style&index=0&id=4900ff05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900ff05",
  null
  
)

export default component.exports